import React from 'react'
import { MDXProvider } from '@mdx-js/tag'
import Layout from './layout'
import Helmet from 'react-helmet'

const BlogPostLayout = ({ children, pageContext }) => {
  console.log(pageContext)
  const { title, date, banner } = pageContext.frontmatter

  return (
    <>
      <Layout>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <article>
          <header>
            <h1>{title}</h1>
            <time>Date: {date}</time>
          </header>
          <MDXProvider>{children}</MDXProvider>
        </article>
      </Layout>
    </>
  )
}

export default BlogPostLayout
